import DataMap from 'assets/components/dataMap/DataMap';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { Fragment } from 'react';
import { useClaimEdit } from '../ClaimEdit.Hooks';
import { combineStrings } from 'assets/utils/data/String';
import User from 'models/core/user/Model.User';

const ClaimEditStatusAuditLogs = () => {
  const { lang } = getLocales();
  const { statusAuditLogs, product } = useClaimEdit();

  return (
    <>
      <h2>{lang.changeLogs}</h2>
      {!statusAuditLogs.length ? (
        <ErrorWrapper id="logs" children={lang.noInfo} />
      ) : (
        <table id="logs" className={ThemeTableSimple}>
          <DataMap
            data={statusAuditLogs}
            render={({ data: log }) => (
              <Fragment key={log.id}>
                <thead>
                  <tr>
                    <th>{lang.claimNumber}</th>
                    <th>{`${lang.claimJob} ${lang.number}`}</th>
                    <th>{lang.oldStatus}</th>
                    <th>{lang.newStatus}</th>
                    <th>{lang.changedOn}</th>
                    <th>{lang.changedBy}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{log.claim?.number ?? 'N/A'}</td>
                    <td>
                      {log.claimJob
                        ? combineStrings(
                            '-',
                            product?.category?.code,
                            log?.claim?.id?.toString(),
                            `J${log?.claimJob?.jobNumber}`
                          )
                        : 'N/A'}
                    </td>
                    <td>{(lang[log.oldStatus] ?? log.oldStatus).replace(/_/g, ' ')}</td>
                    <td>{(lang[log.newStatus] ?? log.newStatus).replace(/_/g, ' ')}</td>
                    <td>{log.createdAtUtc}</td>
                    <td>{new User(log.createdBy)?.displayInfo?.title}</td>
                  </tr>
                </tbody>
              </Fragment>
            )}
          />
        </table>
      )}
    </>
  );
};

export default ClaimEditStatusAuditLogs;
